import { render, staticRenderFns } from "./ConciergeNumber.vue?vue&type=template&id=6cc043e2&scoped=true"
import script from "./ConciergeNumber.vue?vue&type=script&lang=js"
export * from "./ConciergeNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc043e2",
  null
  
)

export default component.exports